import fs from 'fs'
import path from 'path'
import JSZip from 'jszip'

interface Options {
  /**
   * Entry file path
   */
  entry: string

  /**
   * Target zip file path
   */
  target?: string

  /**
   * Emit zip file to file system
   * @default false
   */
  emitFile?: boolean
}

/**
 * Archive dist folder to a zip file
 */
export async function archiveFolderToBase64(options: Options) {
  const { entry, target, emitFile = false } = options

  console.log('Start zipping...')

  // Zip content in .dist folder
  const zip = new JSZip()

  // Get all files in dist folder
  // filter out folders
  const fileList = (
    fs.readdirSync(entry, {
      recursive: true
    }) as string[]
  ).filter((file) => !fs.statSync(path.resolve(entry, file)).isDirectory())

  for (const file of fileList) {
    console.log('Zipping:', file)
    const buffer = fs.readFileSync(path.resolve(entry, file))
    zip.file(file, buffer)
  }

  const buffer = await zip.generateAsync({ type: 'nodebuffer' })
  const base64 = buffer.toString('base64')

  console.log(
    'Zip content:',
    base64.length > 25 ? `${base64.slice(0, 25)}...` : base64,
    calcStringSize(base64)[1]
  )
  console.log('Zip finished.')

  if (emitFile) {
    if (!target) {
      throw new Error('Target path is required when emitFile is true')
    }

    const folderName = path.dirname(target)
    fs.writeFileSync(path.join(target, `${folderName}.zip`), buffer)
  }

  return base64
}

/**
 * Calculate the size of a string in bytes
 * @returns [originSize, sizeFormatted]
 */
export function calcStringSize(str: string) {
  const originSize = new Blob([str]).size
  let size = originSize
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let unitIndex = 0
  while (size > 1024) {
    size /= 1024
    unitIndex++
  }
  return [originSize, size.toFixed(2) + units[unitIndex]] as [number, string]
}
